import React, { useState } from "react";
import { Box, Typography, TextField, Button } from "@mui/material";

const SimpleCapacityPopup = ({ open, onClose, onSubmit, initialData = {} }) => {
  const [capacityForm, setCapacityForm] = useState({
    ticket_accept_limit: initialData.ticket_accept_limit || "",
  });

  const handleChange = (field, value) => {
    setCapacityForm((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleSubmit = () => {
    onSubmit(capacityForm);
  };

  if (!open) return null;

  return (
    <Box
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0,0,0,0.5)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 9999,
      }}
      onClick={onClose}
    >
      <Box
        sx={{
          backgroundColor: "white",
          padding: "20px",
          borderRadius: "8px",
          width: "400px",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <Typography variant="h6" sx={{ marginBottom: "20px" }}>
          Define Center Capacity
        </Typography>

        <Box sx={{ marginBottom: "15px" }}>
          Current Center Capacity:{" "}
          <span style={{ fontWeight: "bold" }}>
            {capacityForm.ticket_accept_limit || "Not Set"}
          </span>
        </Box>

        <Box sx={{ marginBottom: "15px" }}>
          <TextField
            fullWidth
            label="Set Center Limit"
            variant="outlined"
            type="number"
            value={capacityForm.ticket_accept_limit}
            onChange={(e) =>
              handleChange("ticket_accept_limit", e.target.value)
            }
            InputProps={{
              sx: {
                paddingX: "15px",
              },
            }}
          />
        </Box>

        <Button
          variant="contained"
          sx={{ backgroundColor: "#303F9F", color: "white" }}
          onClick={handleSubmit}
          disabled={!capacityForm.ticket_accept_limit}
        >
          Submit
        </Button>
      </Box>
    </Box>
  );
};

export default SimpleCapacityPopup;
